/* SOVOX Cinema — shared behaviour for the cinema-* sections (loaded with defer, runs once per page).
   1. Sticky sub-nav follows the theme's auto-hiding header ([data-ci-sticky]).
   2. Quote list: floating button + drawer, state in localStorage (sovox_cinema_quote).
   3. Series cards: "Choose model" dropdowns ([data-ci-series]).
   4. Spec-note links (¹) reveal the content-visibility sections before jumping. */
(function () {
  'use strict';
  if (window.__sovoxCinema) return;
  window.__sovoxCinema = true;

  /* ---------- 1. sticky sub-nav ---------- */
  var navs = Array.prototype.slice.call(document.querySelectorAll('[data-ci-sticky]'));
  if (navs.length) {
    var header = document.querySelector('.header-section');
    var lastTop = -1, ticking = false, settleUntil = 0;
    var place = function () {
      var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      if (top !== lastTop) {
        lastTop = top;
        for (var i = 0; i < navs.length; i++) navs[i].style.top = top + 'px';
      }
    };
    /* the header slides in/out with a CSS transition after the scroll event, so keep following it briefly */
    var frame = function () {
      place();
      if (performance.now() < settleUntil) { requestAnimationFrame(frame); } else { ticking = false; }
    };
    var kick = function () {
      settleUntil = performance.now() + 450;
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    };
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick, { passive: true });
    kick();
  }

  /* ---------- 2. quote list ---------- */
  var KEY = 'sovox_cinema_quote';
  var drawer = document.querySelector('[data-cq-drawer]');
  var fab = document.querySelector('.cq-fab[data-cq-open]');
  if (drawer && fab) {
    /* theme sections create their own containing block (transform on .section), which would trap
       position:fixed under the sticky header — hoist the drawer and the floating button to <body> */
    document.body.appendChild(drawer);
    document.body.appendChild(fab);
    var list = drawer.querySelector('[data-cq-list]');
    var empty = drawer.querySelector('[data-cq-empty]');
    var field = drawer.querySelector('[data-cq-items-field]');
    var sub = drawer.querySelector('[data-cq-subtitle]');
    var send = drawer.querySelector('[data-cq-send]');
    var load = function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    var esc = function (s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var render = function () {
      var items = load(), units = 0, html = '';
      items.forEach(function (it) {
        units += it.qty;
        html += '<div class="cq-item" data-h="' + esc(it.handle) + '">'
          + '<div class="cq-thumb">' + (it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.model) + '" loading="lazy" decoding="async">' : '') + '</div>'
          + '<div class="cq-meta"><a href="' + esc(it.url) + '">' + esc(it.model) + '</a><span>' + esc(it.type) + (it.fr ? ' · ' + esc(it.fr) : '') + '</span></div>'
          + '<div class="cq-qty"><button type="button" data-cq-dec aria-label="Decrease">−</button><output>' + it.qty + '</output><button type="button" data-cq-inc aria-label="Increase">+</button></div>'
          + '<button type="button" class="cq-rm" data-cq-rm aria-label="Remove"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13"/></svg></button>'
          + '</div>';
      });
      /* the item list is only built into the DOM while the drawer is open (open() re-renders) */
      if (!drawer.hidden) list.innerHTML = html;
      empty.hidden = items.length > 0;
      fab.hidden = items.length === 0;
      document.querySelectorAll('[data-cq-count]').forEach(function (el) { el.textContent = items.length; });
      if (sub) sub.textContent = (sub.getAttribute('data-tpl') || '').replace('{n}', items.length).replace('{u}', units);
      if (field) field.value = items.map(function (it) { return it.model + ' × ' + it.qty; }).join('; ');
      if (send) send.disabled = items.length === 0;
      var handles = {};
      items.forEach(function (it) { handles[it.handle] = true; });
      document.querySelectorAll('[data-cq-item]').forEach(function (card) {
        var btn = card.querySelector('[data-cq-add]');
        if (!btn) return;
        var on = !!handles[card.getAttribute('data-cq-handle')];
        if (btn.classList.contains('is-added') === on && btn.hasAttribute('data-cq-ready')) return;
        btn.setAttribute('data-cq-ready', '');
        btn.classList.toggle('is-added', on);
        var row = btn.closest('.cs-row');
        if (row) row.classList.toggle('is-added', on);
        var lab = btn.querySelector('span');
        if (lab) lab.textContent = on ? (btn.getAttribute('data-label-added') || 'In quote list') : (btn.getAttribute('data-label-add') || 'Add to quote');
      });
    };
    var save = function (items) { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} render(); };
    var lock = function (on) { document.body.style.overflow = on ? 'hidden' : ''; document.documentElement.style.overflow = on ? 'hidden' : ''; };
    var open = function () { drawer.hidden = false; lock(true); render(); };
    var close = function () { drawer.hidden = true; lock(false); };
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cq-add]');
      if (t) {
        var card = t.closest('[data-cq-item]');
        if (!card) return;
        var items = load(), h = card.getAttribute('data-cq-handle');
        var i = items.findIndex(function (it) { return it.handle === h; });
        if (i >= 0) { items.splice(i, 1); save(items); return; }
        items.push({ handle: h, model: card.getAttribute('data-cq-model'), type: card.getAttribute('data-cq-type'), fr: card.getAttribute('data-cq-fr'), url: card.getAttribute('data-cq-url'), img: card.getAttribute('data-cq-img'), qty: 1 });
        save(items);
        if (t.hasAttribute('data-cq-open-after')) open();
        return;
      }
      if (e.target.closest('[data-cq-open]')) { open(); return; }
      if (e.target.closest('[data-cq-close]')) { close(); return; }
      if (e.target.closest('[data-cq-more]')) { if (drawer.contains(e.target) && location.pathname.indexOf('/collections/') !== -1) { e.preventDefault(); close(); } return; }
      var row = e.target.closest('.cq-item');
      if (row && drawer.contains(row)) {
        var items2 = load(), h2 = row.getAttribute('data-h');
        var j = items2.findIndex(function (it) { return it.handle === h2; });
        if (j < 0) return;
        if (e.target.closest('[data-cq-inc]')) items2[j].qty += 1;
        else if (e.target.closest('[data-cq-dec]')) items2[j].qty = Math.max(1, items2[j].qty - 1);
        else if (e.target.closest('[data-cq-rm]')) items2.splice(j, 1);
        else return;
        save(items2);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
    /* the theme scrolls a wrapper rather than <body>, so also stop wheel/touch scrolling on the backdrop */
    var back = drawer.querySelector('.cq-back');
    if (back) {
      back.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
      back.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
    }
    var posted = drawer.querySelector('[data-cq-posted]');
    if (posted) {
      if (posted.classList.contains('ok')) { try { localStorage.removeItem(KEY); } catch (e) {} }
      render(); open();
    } else {
      render();
      if (location.hash === '#quote') open();
    }
  }

  /* ---------- 3. series cards: choose-model dropdowns ---------- */
  document.querySelectorAll('[data-ci-series]').forEach(function (root) {
    var closeAll = function () {
      root.querySelectorAll('.cs-card.is-open').forEach(function (c) {
        c.classList.remove('is-open');
        var d = c.querySelector('.cs-drop'); if (d) d.hidden = true;
      });
    };
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cs-choose]');
      if (btn) {
        var card = btn.closest('.cs-card'), isOpen = card.classList.contains('is-open');
        closeAll();
        if (!isOpen) { card.classList.add('is-open'); card.querySelector('.cs-drop').hidden = false; }
        return;
      }
      var row = e.target.closest('.cs-row');
      if (row && !e.target.closest('[data-cq-add]')) { var t = row.querySelector('[data-cq-add]'); if (t) t.click(); }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.cs-card')) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  });

  /* ---------- 4. spec-note links ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#cs-note-"]');
    if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    /* sections below the fold use content-visibility:auto; render them first so the jump lands exactly */
    document.querySelectorAll('[data-cs-root]').forEach(function (r) { r.classList.add('cs-shown'); });
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
    });
  });
})();
